export default "__VITE_ASSET__BxCznsQc__"